import React from "react";
import { useState } from 'react';
import { Box, Card, Button, Paper,  Dialog, Typography,DialogActions,DialogTitle,
  DialogContent, CardContent, Grid, Tooltip, Stack } from "@mui/material";
import Header from "../components/Header";
import { useLocation, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import Iconify from '../components/iconify';

const Logo = "/assests/images/logo512.png";

function Services() {
  const location = useLocation();
  const navigate = useNavigate();
  const { groups, services, branchDetails } = location.state || {};
 
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  //console.log(services);
  const handleChangeService = (service) => {
    if (!service.isActive) {
      alert(`Service is currently unavailable and will be available from ${service.startTime} to ${service.endTime}.`);
      return;
    }

    console.log('service',service); 
   // setSelectedService(service.serviceId);
    navigate("/offline-ticket", {
      state: {
        serviceId: service.serviceId,
        serviceName: service.serviceName,
        branchDetails,
        services,
        groups,
      },
    });
  };

  const handlehome = () => {
    navigate("/"); // Adjust the path to your main route
  };

const handleGroupClick = (group) => {
  setSelectedGroup(group);
  setOpenDialog(true);
};

const handleCloseDialog = () => {
  setOpenDialog(false);
  setSelectedGroup(null);
};

  return (
    <Box
      sx={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#f0f2f5",
        display: "flex",
        flexDirection: "column",
        overflow: "auto",
      }}
    >
      <Header />
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          padding: 0,
        }}
      >
        <Card
          sx={{
            padding: 3,
            backgroundColor: "rgba(0, 0, 0, 0)",
            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: 3,
              paddingLeft: { xs: 2, sm: 10, md: 20 },
              paddingRight: { xs: 2, sm: 10, md: 20 },
            }}
          >
            <Button
              variant="outlined"
              sx={{
                borderColor: "#1877f2",
                color: "#1877f2",
                borderRadius: 2,
                height: 60,
                minWidth: 80,
                padding: "0 12px",
              }}
              onClick={handlehome}
            >
              <HomeIcon style={{ color: "#064EB4" }} />
            </Button>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", textAlign: "center", flexGrow: 1 }}
            >
              Select a Service
            </Typography>
          </Box>
          <Box
            sx={{
              paddingLeft: { xs: 2, sm: 10, md: 20 },
              paddingRight: { xs: 2, sm: 10, md: 20 },
              flexGrow: 1,
            }}
          >
            <Grid container spacing={3} >
              {services && services.length > 0 ? (
                services
                  .map((service) => (
                    <Grid spacing={1} item xs={12} sm={6} md={4} lg={4} key={service.serviceId}>
                      <Tooltip title={service.serviceName} arrow>
                        <Card
                          onClick={() => handleChangeService(service)}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            padding: { xs: 1, sm: 2 },
                            backgroundColor: "#ffffff",
                            textAlign: "center",
                            minHeight: 50, // Prevents squishing
                            width: "83%",
                            maxWidth: 360,
                            borderRadius: 2,
                            boxShadow: 3,
                            border: "1px solid #a0c8f0",
                          }}
                        >
                          <Stack spacing={1} alignItems="center">
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: { xs: "0.9rem", sm: "1rem" },
                                color: "#064EB4",
                                textTransform: "uppercase",
                                wordWrap: "break-word",
                              }}
                            >
                              {service.serviceName}
                            </Typography>
                          </Stack>
                        </Card>
                      </Tooltip>
                    </Grid>
                  ))
              ) : (
                <Typography variant="h6" align="center" sx={{ flexGrow: 1 }}>
                 
                </Typography>
              )}

             {groups.map((group) => (
             <Grid spacing={1} item xs={12} sm={6} md={4} lg={4} key={group.group_name}>
                      <Tooltip title={group.group_name} arrow>
              <Card
                key={group.group_name} 
               sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            padding: { xs: 1,},
                            backgroundColor: "#ffffff",
                            textAlign: "center",
                            minHeight: 30,
                            width: "87%",
                            maxWidth: 360,
                            borderRadius: 2,
                            boxShadow: 3,
                            border: "1px solid #a0c8f0",
                          }}
              >
                <CardContent
                  onClick={() => handleGroupClick(group)}
                  sx={{ cursor: 'pointer' }}
                >
                  <Typography
                    variant="body1"
                  sx={{
                                fontWeight: "bold",
                                textAlign: "center",
                                fontSize: { xs: "0.8rem", sm: "1rem" },
                                color: "#064EB4",
                                textTransform: "uppercase",
                                wordWrap: "break-word",
                              }}
                  >
                    {group.group_name}
                    <Iconify icon="eva:arrow-ios-downward-fill" width={20} height={20} />
                  </Typography>
                </CardContent>
              </Card>
                </Tooltip>
                    </Grid>
))}


            </Grid>




<Dialog
  open={openDialog}
  onClose={handleCloseDialog}
  fullWidth
  maxWidth="md"
>
  <DialogTitle>
    {selectedGroup?.group_name}
  </DialogTitle>

  <DialogContent dividers>
    <Grid container spacing={2} justifyContent="left">
      {selectedGroup?.services.map((service) => (
        <Grid item xs={12} sm={6} md={4} key={service.serviceId}>
          <Tooltip title={service.serviceName} arrow>
            <Card
              onClick={() => {
                handleChangeService(service);
                handleCloseDialog();
              }}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                padding: { xs: 1, sm: 2 },
                backgroundColor: "#ffffff",
                textAlign: "center",
                minHeight: 50,
                maxWidth: 360,
                margin: "0 auto",
                borderRadius: 2,
                boxShadow: 3,
                border: "1px solid #a0c8f0",
              }}
            >
              <Stack spacing={1} alignItems="center">
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    textAlign: "center",
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    color: "#064EB4",
                    textTransform: "uppercase",
                    wordWrap: "break-word",
                  }}
                >
                  {service.serviceName}
                </Typography>
              </Stack>
            </Card>
          </Tooltip>
        </Grid>
      ))}
    </Grid>
  </DialogContent>

  <DialogActions>
    <Button onClick={handleCloseDialog} variant="outlined"
                              sx={{
                                borderColor: "#1877f2",
                                color: "#1877f2",
                                borderRadius: 2,
                                height: 50,
                              }}>
      Close
    </Button>
  </DialogActions>
</Dialog>



          </Box>
        </Card>
      </Box>
    </Box>
  );
}

export default Services;
